<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-row justify="center" align="center" class="login-container">
      <v-col cols="12" md="8" lg="7">
        <v-card class="login-card" elevation="8">
          <v-card-title class="text-center">
            <img
              src="/img/siglasigfoco.svg"
              alt="Brasão do estado de Pernambuco"
              class="login-logo mb-5"
            />
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="user.username"
                solo
                hide-details="auto"
                placeholder="CPF"
                v-mask="'###.###.###-##'"
                :rules="[(v) => $required(v, 'CPF é obrigatório')]"
                @keyup.enter="enter"
                prepend-inner-icon="mdi-account"
                class="mb-4"
              ></v-text-field>
              <v-text-field
                v-model="user.password"
                type="password"
                solo
                maxlength="256"
                placeholder="Senha"
                hide-details="auto"
                :rules="[
                  (v) => $required(v, 'Senha é obrigatória'),
                  (v) => $min(v, 8, 'A senha deve conter pelo menos 8 caracteres.'),
                  (v) => $max(v, 256, 'A senha deve conter no máximo 256 caracteres.'),
                ]"
                @keyup.enter="enter"
                prepend-inner-icon="mdi-lock"
                class="mb-4"
              ></v-text-field>
              <v-row v-if="$recaptchaDev">
                <v-col>
                  <small>
                    <sigfoco-recaptcha v-on:recaptchaVerified="verified = $event" />
                  </small>
                </v-col>
              </v-row>
              <v-btn
                block
                color="success"
                :loading="loading"
                @click.prevent="enter"
                class="mt-4"
              >
                Entrar
              </v-btn>
              <v-row class="mt-4">
                <v-col class="py-0 mt-3 text-center">
                  <small>
                    <a @click="toggleModalRedefinirSenha(true)"> 
                      Esqueci minha senha ou não tenho senha cadastrada
                    </a>
                  </small>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="visible" width="50%">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">Selecione o tipo de usuário:</div>
        </v-toolbar>
        <div class="container dialog mt-7">
          <v-row class="text-center">
            <p>Para redefinir sua senha, selecione a opção correspondente ao seu tipo de acesso:</p>
            <li>Servidor do SAD-RH: Caso você acesse o sistema com as credenciais do SAD-RH.</li>
            <li>Servidor Cadastrado: Caso você tenha definido sua senha após o cadastro por e-mail.</li>
          </v-row>
        </div>
        <div class="text-center mt-5">
          <v-btn
            color="primary"
            class="ml-2 text-body-2 font-weight-medium"
            @click="redirectTo('SADRH')"
          >
            Servidor do SAD-RH
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2 text-body-2 font-weight-medium"
            @click="redirectTo('Cadastrado')"
          >
            Servidor Cadastrado
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2 text-body-2 font-weight-medium"
            @click="toggleModalRedefinirSenha(false)"
          >
            Cancelar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { LOGIN } from "store/modules/auth";
import { CLEAR } from "store";
export default {
  data: () => ({
    loading: false,
    verified: false,
    valid: false,
    visible: false,
    user: {
      username: undefined,
      password: undefined,
    },
  }),
  beforeMount() {
    this.hidePageLoading();
    this.$store.dispatch(CLEAR);
  },
  methods: {
    enter() {
      this.$refs.form.validate();

      if (!this.valid) {
        return;
      }
      if (!this.verified && this.$recaptchaDev) {
        return this.$notifyWarning("Conclua o reCAPTCHA para continuar.");
      }
      this.loading = true;
      const cpf = this.$removeCpfMask(this.user.username);
      this.$realizarLogin({
        nomeDeUsuario: cpf,
        senha: this.user.password,
      }).then(({ data }) => {
        this[LOGIN](data).then(() => {
          this.$atualizarCacheMenu().then(() => {
            this.$toHome();
          });
        });
      }).catch(() => this.$store.dispatch(CLEAR)).finally(() => this.loading = false);
    },
    redirectTo(tipoServidor) {
      switch(tipoServidor) {
        case 'SADRH': {
          return window.open("https://www.nps.pe.gov.br/PORTALV2/#/", "_blank");
        }
        case 'Cadastrado': {
          return this.$router.push({ path: "/recuperar-senha" });
        }
      }
    },
    toggleModalRedefinirSenha(visible) {
      this.visible = visible;
    },
  },
};
</script>

<style scoped lang="scss">
.fill-height {
  height: 100vh;
}

.login-container {
  width: 100%;
  max-width: 50%;
}

.login-card {
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.login-logo {
  max-width: 150px;
  margin: 0 auto;
}

.v-text-field__slot input {
  font-size: 1.1rem;
}

.v-btn {
  font-size: 1.1rem;
  font-weight: bold;
}

a {
  color: rgb(47, 31, 168);
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

form {
  min-width: 250px;
  a {
    text-decoration: none;
  }
}
</style>